"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _QyGroupDinnerTablePane = _interopRequireDefault(require("./QyGroupDinnerTablePane.vue"));
var _QyGroupDinnerConfigPane = _interopRequireDefault(require("./QyGroupDinnerConfigPane.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'qy_group_dinner',
  components: {
    QyGroupDinnerTablePane: _QyGroupDinnerTablePane.default,
    QyGroupDinnerConfigPane: _QyGroupDinnerConfigPane.default
  },
  data: function data() {
    return {
      activeTab: 'table',
      currentActivityId: null
    };
  },
  methods: {
    handleAdd: function handleAdd() {
      this.currentActivityId = null;
      this.activeTab = 'config';
    },
    handleEdit: function handleEdit(activityId) {
      this.currentActivityId = activityId;
      this.activeTab = 'config';
    },
    handleSave: function handleSave() {
      this.activeTab = 'table';
      this.$refs.tablePane && this.$refs.tablePane.loadData();
    },
    handleCancel: function handleCancel() {
      var _this = this;
      // 确保切换到活动列表 tab
      this.$nextTick(function () {
        _this.activeTab = 'table';
      });
    },
    handleRefresh: function handleRefresh() {
      this.$refs.tablePane && this.$refs.tablePane.loadData();
    }
  }
};